<template>
  <section class="admin-initialization-error">
    <p class="admin-initialization-error__eyebrow">{{ t('admin.initialization.eyebrow') }}</p>
    <h1>{{ t('admin.initialization.title') }}</h1>
    <p>{{ t('admin.initialization.description') }}</p>
    <el-button type="primary" :loading="application.initializing" @click="retry">
      {{ t('admin.initialization.retry') }}
    </el-button>
  </section>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import { useAdminApplicationStore } from '@/stores/admin/application'

const route = useRoute()
const router = useRouter()
const application = useAdminApplicationStore()
const { t } = useI18n()

const getRedirect = (): string => {
  const redirect = route.query.redirect
  return typeof redirect === 'string' && redirect.startsWith('/admin')
    ? redirect
    : '/admin/dashboard'
}

const retry = async (): Promise<void> => {
  try {
    await application.initialize(router, true)
    await router.replace(getRedirect())
  } catch {
    // Store 保留可重试状态，页面不暴露服务端细节。
  }
}
</script>

<style scoped>
.admin-initialization-error {
  padding: var(--admin-page-padding);
}

.admin-initialization-error__eyebrow {
  margin: 0;
  color: var(--admin-color-danger);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.admin-initialization-error h1 {
  margin: 8px 0 12px;
}

.admin-initialization-error p:not(.admin-initialization-error__eyebrow) {
  margin: 0 0 20px;
  color: var(--admin-color-text-secondary);
}
</style>
